var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('full-width-bg-generic',{attrs:{"displayIcon":"","backgroundType":1}}),_c('account-settings',{staticClass:"container mx-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }